import { service } from '@ember/service';
import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PartnerService from 'tio-employee/services/partner';
import type SessionContextService from 'tio-employee/services/session-context';
import type EmployeeModel from 'tio-common/models/employee';

export default class AuthenticatedTasMentoringRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare partner: PartnerService;

  async model() {
    // @ts-expect-error: fix model types
    const employee = await this.store.findRecord<EmployeeModel>(
      'employee',
      this.sessionContext.currentEmployee.id
    );

    return { employee: employee, hasSupport: this.isSupportEnabled };
  }

  get isSupportEnabled() {
    return this.partner.isAnySupportEnabled;
  }
}
